<template>
  <v-dialog
    v-model="visible"
    hide-overlay
    persistent
    width="300"
  >
    <v-card
      color="primary"
      dark
    >
      <v-card-text class="pt-3">
        <div class="text-center mb-3">{{ text }}</div>
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { onUnmounted, watch } from '@vue/composition-api'

// piu' loader possono essere montati contemporaneamente (es. AssistenzaCreate + PickupAssistance),
// quindi il blocco sul body va contato: si sblocca solo quando l'ultimo loader si chiude.
let locks = 0

const lockBody = () => {
  locks += 1
  document.body.style.setProperty('pointer-events', 'none')
}

const unlockBody = () => {
  locks = Math.max(0, locks - 1)
  if (locks === 0) {
    document.body.style.removeProperty('pointer-events')
  }
}

export default {
  props: {
    visible: {
      required: true,
      type: Boolean,
    },

    text: {
      required: false,
      type: String,
      default: 'Attendere',
    },
  },
  setup(props) {
    // tengo traccia del lock di questa istanza: se il componente viene distrutto
    // durante un cambio di route il watcher non fa in tempo a girare e il body
    // resterebbe con pointer-events: none.
    let hasLock = false

    watch(() => props.visible, newVal => {
      if (newVal && !hasLock) {
        hasLock = true
        lockBody()
      } else if (!newVal && hasLock) {
        hasLock = false
        unlockBody()
      }
    })

    onUnmounted(() => {
      if (hasLock) {
        hasLock = false
        unlockBody()
      }
    })

    return {
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@core/preset/preset/pages/auth';
</style>
